export default "__VITE_ASSET__BPs$qkxE__"